import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'

import './surveyLicenceModal.scss'

const NoLicenceModal = ({ store }) => (
    <Modal
        show={store.noLicenceModalVisible}
        onClose={store.hideNoLicenceModal}
    >
        <div className="licence-modal-title-container">
            <Typography type="h3">
                {i18n.t('noSurveyLicenceModal.title')}
            </Typography>

            <p dangerouslySetInnerHTML={{ __html: i18n.t('noSurveyLicenceModal.subtitle')}} />
        </div>
    </Modal>
)

export default observer(NoLicenceModal)
